import { reactive } from "vue";
import { useRouter } from "vue-router";
import store from "@/store";
import axios from "axios";

const useAuth = () => {
  const router = useRouter();
  const base_url = store.state.baseUrl;

  const state = reactive({
    user: JSON.parse(sessionStorage.getItem("user")) || null,
    isAuthenticated:
      JSON.parse(sessionStorage.getItem("isAuthenticated")) || false,
    message: {
      type: "",
      content: "",
    },
  });

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${base_url}login`, {
        email,
        password,
      });

      state.user = response.data.user;
      state.isAuthenticated = true;
      state.message = { type: "success", content: response.data.message };

      sessionStorage.setItem("user", JSON.stringify(state.user));
      sessionStorage.setItem(
        "isAuthenticated",
        JSON.stringify(state.isAuthenticated)
      );
    } catch (error) {
      console.error("Login failed:", error);
      state.message = {
        type: "error",
        content: error.response?.data?.message || "Login failed",
      };
    }
  };

  const register = async (name, email, password) => {
    try {
      const response = await axios.post(`${base_url}register`, {
        name,
        email,
        password,
      });

      state.user = response.data.user;
      state.isAuthenticated = true;
      state.message = { type: "success", content: response.data.message };

      sessionStorage.setItem("user", JSON.stringify(state.user));
      sessionStorage.setItem(
        "isAuthenticated",
        JSON.stringify(state.isAuthenticated)
      );

      router.push("/");
    } catch (error) {
      console.error("Registration failed:", error);
      state.message = {
        type: "error",
        content: error.response?.data?.message || "Registration failed",
      };
    }
  };

  const forgotPassword = async (email) => {
    try {
      const response = await axios.post(`${base_url}password-reset-link`, {
        email,
      });

      state.message = { type: "success", content: response.data.message };
    } catch (error) {
      console.error("Password reset failed:", error);
      state.message = {
        type: "error",
        content: error.response?.data?.message || "Password reset failed",
      };
    }
  };

  const isAuthenticated = () => {
    return state.isAuthenticated;
  };

  const logout = () => {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("isAuthenticated");

    state.user = null;
    state.isAuthenticated = false;

    window.location.reload();
  };

  return { state, login, register, forgotPassword, isAuthenticated, logout };
};

export default useAuth;
